import React, { Component, Fragment } from 'react';
import { Container, Row, Col } from 'react-grid-system';

import { Select } from 'components/cosmos';
import { Grid } from 'components/grid';
import { translate } from 'components/translate';
import { ClassesService } from 'modules/content';

import ImportButton from './ImportButton';

import ImportService from '../ImportService';

@translate()
export default class HotmartImport extends Component {
  state = {
    selectedClass: null,
    classesList: [],
    loading: true
  };

  componentDidMount() {
    this.fetchClassesList();
  }

  fetchClassesList = async () => {
    const classes = await ClassesService.getSelectFormatedClasses();

    this.setState({
      classesList: classes,
      selectedClass: classes[0],
      loading: false
    });
  };

  toggleLoader = () => {
    this.setState((prevState) => ({
      loading: !prevState.loading
    }));
  };

  setClass = (selectedClass) => {
    this.setState({ selectedClass });
  };

  hotmartImport = async () => {
    this.toggleLoader();
    await ImportService.hotmartImport(this.state.selectedClass);
    this.toggleLoader();
  };

  render() {
    const { classesList, selectedClass, loading } = this.state;
    const { t } = this.props;

    return (
      <Fragment>
        <Grid block>
          <h2>{t('users_import.hotmart.title')}</h2>
          <label className="label__subtitle mb__md">
            {t('users_import.hotmart.description')}
          </label>

          <Container fluid className="users__form p__0">
            <Row justify="between">
              <Col xs={12} sm={6} md={6} lg={4}>
                <Select
                  label={t('users_import.batch.class.label')}
                  labelClassName="_mt-0"
                  onChange={this.setClass}
                  options={classesList}
                  value={selectedClass}
                  placeholder={t('users_import.batch.class.placeholder')}
                />
              </Col>
            </Row>
          </Container>
        </Grid>

        <ImportButton
          isDisabled={loading}
          data-test="hotmart-import"
          onClick={this.hotmartImport}
        />
      </Fragment>
    );
  }
}
